import Vue from 'vue'
import axios from 'axios'
import VueJsonp from 'vue-jsonp'
import VueCookies from 'vue-cookies'

Vue.use(VueJsonp)
Vue.use(VueCookies)
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.baseURL='/cbl'
// 请求拦截器
axios.interceptors.request.use(function(config) {
    return config;
  }, function(error) {
    return Promise.reject(error);
  })
  // 响应拦截器
axios.interceptors.response.use(res =>{
  return res
},err =>{
  // 检查当前页面是否是 case.html，如果是则不跳转到登录页面
  if (err.message.includes('code 403') && !location.pathname.includes('case.html')) {
    localStorage.setItem("Referer",location.href)
    window.location.href = 'login.html'
    return
  }
  if (err.message.includes('code 500')) {
    console.log('服务器发生500异常，未获取到数据！')
  }
  if (err.message === 'Network Error') {
    console.log('网络错误，请检查网络是否通畅、或者服务器地址设置正确,设置服务器地址可以自行到登录页面设置.')
  }
  return Promise.reject(new Error(err))
})
 
export default axios


// WEBPACK FOOTER //
// ./src/api.js